// @flow
import { take, put, select } from 'redux-saga/effects';

import { LOGIN_FAILED, LOGIN_SUCCESS } from '@screens/SignIn/redux/constants';

import { requestAccessToken, logout } from '@screens/SignIn/redux/actions';
import type { Action } from '@screens/SignIn/types';
import type { GlobalState } from '@globalTypes';
import type { AxiosError } from './types';


export const refreshTokenSelector = (state: GlobalState): ?string => state.login.refreshToken;

function* handleApiErrors(error: AxiosError, action: Action): Generator<Function, void, void> {
  switch ((error.response || {}).status) {
    case 401: {
      const refreshToken: ?string = yield select(refreshTokenSelector);

      yield put(requestAccessToken(refreshToken || ''));

      const loginAction: ?Action = yield take([LOGIN_FAILED, LOGIN_SUCCESS]);

      if (loginAction && loginAction.type === LOGIN_SUCCESS) {
        yield put(action);
      } else {
        yield put(logout());
      }

      break;
    }

    default:
      break;
  }
}

export default handleApiErrors;
